/**
 * Marks a drawer that can open over the Post sheet (E16's PIN entry, B7's sign-in prompt). While a
 * marked drawer is open, the sheet's own scrim turns transparent (`PostSheet`'s overlay class keys
 * on this attribute), so one scrim dims the screen instead of two stacked 80% ones (~96% black).
 * Harmless with no sheet open: the rule only touches the sheet's overlay.
 */
export const COVERS_POST_SHEET = { 'data-covers-post-sheet': '' } as const;
